import { makeH0, makeH1, makeH2, makeH3, makeH4, makeH5, makeH6, makeTypography, makeFemto, makeNano, makeMicro, makeSmall, makeText, makeBig, makeBigger, makeHuge, } from "./typography";
export { makeTypography, makeH0, makeH1, makeH2, makeH3, makeH4, makeH5, makeH6, makeFemto, makeNano, makeMicro, makeSmall, makeText, makeBig, makeBigger, makeHuge, };
export var H0 = makeH0("h1");
export var H1 = makeH1("h1");
export var H2 = makeH2("h2");
export var H3 = makeH3("h3");
export var H4 = makeH4("h4");
export var H5 = makeH5("h5");
export var H6 = makeH6("h6");
export var TextFemto = makeFemto("span");
export var TextNano = makeNano("span");
export var TextMicro = makeMicro("span");
export var TextSmall = makeSmall("span");
export var Text = makeText("span");
export var TextBig = makeBig("span");
export var TextBigger = makeBigger("span");
export var TextHuge = makeHuge("span");
export { List, ListItem } from "./list";
